/**
 * The class list for a section's outer surface.
 *
 * Lives in its own module rather than in `index.tsx` because `index.tsx` imports the
 * section components from `Counter.tsx` and `Forms.tsx`, and those need this too — a
 * shared helper in `index.tsx` would close the import cycle.
 */

/** How a section is framed. Mirrors `groundSchema` in `@serendib/shared`. */
export type Ground = 'panel' | 'open';

/**
 * `open` is ignored on a dark section, and that is not an oversight.
 *
 * `.panel--open` works by removing the background, so applying it to `.panel--dark`
 * would delete the dark ground and leave text sitting on the canvas — a section that
 * is not merely unstyled but unreadable, since `.on-dark` has already re-pointed the
 * ink to near-white. A dark section has no card to remove; it IS the emphasis that
 * `open` exists to make room for.
 */
export function panelClass({ ground, dark, flush }: { ground?: Ground | null; dark?: boolean; flush?: boolean } = {}): string {
  return [
    'panel',
    dark ? 'panel--dark on-dark' : ground === 'open' ? 'panel--open' : '',
    flush ? 'panel--flush' : '',
  ]
    .filter(Boolean)
    .join(' ');
}
